import { PersistStorage } from "zustand/middleware";
import CryptoJS from "crypto-js";

const SECRET_KEY: string = process.env.STORAGE_ENCRYPTION_KEY!;

export class EncryptedStorage implements PersistStorage<any> {
  getItem(key: string): any | undefined {
    const value: string | null = localStorage.getItem(key);

    if (value) {
      try {
        const decryptedBytes = CryptoJS.AES.decrypt(value, SECRET_KEY);
        const decryptedValue = decryptedBytes.toString(CryptoJS.enc.Utf8);
        return decryptedValue ? JSON.parse(decryptedValue) : undefined;
        // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
      } catch (error) {
        // if (error instanceof Error) {
        //   console.log(error.message);
        // }
      }
    }

    return undefined;
  }

  setItem(key: string, value: any): void {
    try {
      const stringValue = JSON.stringify(value);
      const encrypted = CryptoJS.AES.encrypt(
        stringValue,
        SECRET_KEY,
      ).toString();
      localStorage.setItem(key, encrypted);
      // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    } catch (error) {
      // if (error instanceof Error) {
      //   console.log(error.message);
      // }
      return undefined;
    }
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }
}
